import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LoadingIndicatorComponent } from '@unicup-ticketing/ui';
import { AuthenticationStateStore } from '@unicup-ticketing/auth';
import { StaffDrawItemComponent } from '../components/staff-draw-item/staff-draw-item.component';
import { StaffProfileStateStore } from './staff-profile.state';

@Component({
  selector: 'pos-profile',
  providers: [StaffProfileStateStore],
  imports: [LoadingIndicatorComponent, StaffDrawItemComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileComponent {
  protected readonly state = inject(StaffProfileStateStore);

  private readonly authState = inject(AuthenticationStateStore);

  protected readonly givenName = computed(() => this.authState.idToken()?.user.givenName);
}
